// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J57Cz{display:flex;align-items:center;justify-content:center;height:100%;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tick": `J57Cz`
};
export default ___CSS_LOADER_EXPORT___;
